import { render, staticRenderFns } from "./SignUpPageOverview.vue?vue&type=template&id=460c0eb2&scoped=true&"
import script from "./SignUpPageOverview.vue?vue&type=script&lang=js&"
export * from "./SignUpPageOverview.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPageOverview.vue?vue&type=style&index=0&id=460c0eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c0eb2",
  null
  
)

export default component.exports